import FunnelChart from './funnel-chart.vue';

FunnelChart.install = function install(Vue) {
  Vue.component(FunnelChart.name, FunnelChart);
};

export default FunnelChart;
